module.exports = __webpack_public_path__ + "img/back_length_to_waist.1bfd77f7.png";